import configurationRequestActionTypes from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';
import { combineReducers } from 'redux';

export const asyncRequestReducers = {
  queryLayouts: createAsyncRequestReducer(
    configurationRequestActionTypes.FETCH_LAYOUTS,
  ),
};

export default combineReducers(asyncRequestReducers);
